const identicalCharactersRegex = /^(.)\1{1,}$/;

const isSequential = (tin) => {
  if (tin.length === 1) {
    return false;
  }

  for (let i = 0; i < tin.length - 1; i += 1) {
    if (i < tin.length - 1) {
      let currentNumber = parseInt(tin[i], 10);
      const nextNumber = parseInt(tin[i + 1], 10);
      currentNumber += 1;
      if (currentNumber !== nextNumber) {
        return false;
      }
    }
  }
  return true;
};

export const getTinErrorMessage = (fullTinEntry, fieldLength, isRequired) => {
  let customError = '';

  if (fullTinEntry === '' && isRequired) {
    customError = 'Please provide a TIN';
  } else if (fullTinEntry !== '') {
    if (fieldLength && fullTinEntry.length !== fieldLength) {
      customError = `A TIN must contain ${ fieldLength } characters`;
    } else if (identicalCharactersRegex.test(fullTinEntry)) {
      customError = 'A TIN cannot be composed of identical characters.';
    } else if (isSequential(fullTinEntry)) {
      customError = 'A TIN cannot be composed of sequential numbers.';
    } else {
      return false;
    }
  }

  return customError;
};

export const getTinFormatFromQuestions = (questions) => {
  if (!questions) {
    return '';
  }
  const tinType = questions.find(q => q.setsTinInputFormat && q.inputs && q.inputs.itemsTinFormats);
  if (!tinType || !tinType.answer || !tinType.inputs || !tinType.inputs.items) {
    return '';
  }
  const tinAnswerIndex = tinType.inputs.items.findIndex(i => i.value === Number(tinType.answer));
  if (tinAnswerIndex !== -1) {
    return tinType.inputs.itemsTinFormats[tinAnswerIndex];
  }
  return '';
};
